import { Typography } from '@recruit-robin/robin-theme/web-components';
import { AlertCircle, Check, InfoCircle, Star_06, XClose } from '@recruit-robin/robin-theme/web-icons';
import { useMemo } from 'react';
import { useStyles } from './MessageInfo.styles';
import { MessageInfoProps, MessageInfoStyleProps, MessageInfoVariant } from './MessageInfo.types';

export const MessageInfo = ({
  className,
  message,
  onRequestClose,
  variant = MessageInfoVariant.Default,
}: MessageInfoProps) => {
  const classes = useStyles<MessageInfoStyleProps>({ variant });

  const icon = useMemo(() => {
    switch (variant) {
      case MessageInfoVariant.Default:
        return <InfoCircle size={14} />;

      case MessageInfoVariant.Success:
        return <Check size={14} />;

      case MessageInfoVariant.Ai:
        return <Star_06 size={14} />;

      case MessageInfoVariant.Danger:
        return <AlertCircle size={14} />;
    }
  }, [variant]);

  return (
    <div css={classes.root} className={className}>
      <div css={classes.icon}>{icon}</div>
      <div css={classes.message}>
        <Typography variant={(v) => v.supporting.helper}>{message}</Typography>
      </div>
      {onRequestClose && (
        <div css={classes.close} onClick={onRequestClose}>
          <XClose size={24} />
        </div>
      )}
    </div>
  );
};
